import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export function trigger(rootDir = '') {
  window.addEventListener('load', () => {
    gsap.registerPlugin(ScrollTrigger);

    // 共通 / トリガー
    const triggerAreas = document.getElementsByClassName('js-trigger-area');
    for (let i = 0; i < triggerAreas.length; i++) {
      const activeArea = triggerAreas[i];
      ScrollTrigger.create({
        trigger: activeArea,
        start: 'top 70%',
        // markers: true,
        onEnter: () => {
          const items = activeArea.getElementsByClassName('js-trigger-item');
          for (let j = 0; j < items.length; j++) {
            items[j].classList.add('is-active');
          }
        },
      });
    }

    // 当該要素に対して
    document.querySelectorAll('.js-top-trigger').forEach((singleTrigger) => {
      ScrollTrigger.create({
        trigger: singleTrigger,
        start: 'top 80%',
        onEnter: () => singleTrigger.classList.add('is-active'),
        onEnterBack: () => singleTrigger.classList.add('is-active'),
        // markers: true,
      });
    });
    document.querySelectorAll('.js-bottom-trigger').forEach((singleTrigger) => {
      ScrollTrigger.create({
        trigger: singleTrigger,
        start: 'bottom 100%',
        onEnter: () => singleTrigger.classList.add('is-active'),
        onEnterBack: () => singleTrigger.classList.add('is-active'),
        // markers: true,
      });
    });

    // 当該要素の通り抜け
    document
      .querySelectorAll('.js-passing-trigger')
      .forEach((singleTrigger) => {
        ScrollTrigger.create({
          trigger: singleTrigger,
          start: 'top 80%',
          end: 'top 20%',
          onEnter: () => {
            singleTrigger.classList.add('is-active');
            singleTrigger.classList.remove('is-passed');
          },
          onEnterBack: () => {
            singleTrigger.classList.add('is-active');
            singleTrigger.classList.remove('is-passed');
          },
          onLeave: () => {
            singleTrigger.classList.remove('is-active');
            singleTrigger.classList.add('is-passed');
          },
          onLeaveBack: () => {
            singleTrigger.classList.remove('is-active');
            singleTrigger.classList.remove('is-passed');
          },
          // markers: true,
        });
      });
  });
}
